(function () {
  'use strict';

  if (window.__VSKLO_BESTSELLERS_LOADER_V3__) return;
  window.__VSKLO_BESTSELLERS_LOADER_V3__ = true;

  var loading = null;
  var observer = null;
  var retryTimer = 0;

  function resetObservation() {
    if (observer) {
      try { observer.disconnect(); } catch (error) {}
      observer = null;
    }
    document.querySelectorAll('.bestsellers-swiper[data-vsklo-bestseller-observed="true"]').forEach(function (slider) {
      delete slider.dataset.vskloBestsellerObserved;
    });
  }

  function scheduleRetry() {
    window.clearTimeout(retryTimer);
    retryTimer = window.setTimeout(function () {
      retryTimer = 0;
      if (!window.__VSKLO_BESTSELLERS_NAV_V3__) observeRoot(document);
    }, 1200);
  }

  function hasSlider(root) {
    var scope = root && root.querySelector ? root : document;
    if (scope.matches && scope.matches('.bestsellers-swiper')) return true;
    return Boolean(scope.querySelector('.bestsellers-swiper'));
  }

  function ensureRuntime(root) {
    if (!hasSlider(root)) return Promise.resolve();
    if (window.__VSKLO_BESTSELLERS_NAV_V3__) return Promise.resolve();
    if (!loading) {
      loading = import('./vsklo-bestsellers-slider-runtime.js?v=3').catch(function (error) {
        loading = null;
        resetObservation();
        scheduleRetry();
        console.error('[VSKLO] Bestsellers runtime failed to load:', error);
        throw error;
      });
    }
    return loading;
  }

  function observeRoot(root) {
    var scope = root && root.querySelector ? root : document;
    var sliders = [];
    if (scope.matches && scope.matches('.bestsellers-swiper')) sliders.push(scope);
    if (scope.querySelectorAll) sliders = sliders.concat(Array.prototype.slice.call(scope.querySelectorAll('.bestsellers-swiper')));
    if (!sliders.length) return;

    if (!('IntersectionObserver' in window)) {
      ensureRuntime(scope);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        var hit = entries.some(function (entry) { return entry.isIntersecting; });
        if (!hit) return;
        observer.disconnect();
        observer = null;
        ensureRuntime(document).catch(function () {
          // resetObservation() + scheduleRetry() are owned by ensureRuntime().
        });
      }, { rootMargin: '800px 0px' });
    }

    sliders.forEach(function (slider) {
      if (slider.dataset.vskloBestsellerObserved === 'true') return;
      slider.dataset.vskloBestsellerObserved = 'true';
      observer.observe(slider);
    });
  }

  function bootstrap() {
    if (window.Shopify && window.Shopify.designMode) ensureRuntime(document);
    else observeRoot(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
  else bootstrap();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    if (window.Shopify && window.Shopify.designMode) ensureRuntime(event.target);
    else observeRoot(event.target);
  });
})();
